import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, LocationStrategy, HashLocationStrategy, PathLocationStrategy } from '@angular/common';
import { DefaultModule } from './components/default.module';
import { AlertComponent } from './components/alert';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { NgPipesModule } from 'ngx-pipes';
import { NgSelectModule } from '@ng-select/ng-select';
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';

import { HeaderComponent } from './components/include/header/header.component';
import { FooterComponent } from './components/include/footer/footer.component';
import { SubFooterComponent } from './components/include/footer/sub-footer/sub-footer.component';
import { ProductsComponent } from './components/product/products.component';
import { ProductListComponent } from './components/product/product-list/product-list.component';
import { ProductCardComponent } from './components/product/product-list/product-card/product-card.component';
import { FiltersComponent } from './components/product/filters/filters.component';
import { ProductDetailsComponent } from './components/product/product-details/product-details.component';
import { SharedModule } from './components/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { SendEnquiryComponent } from './components/sharedComponents/enquiry/send-enquiry.component';
import { CategoriesListComponent } from './components/sharedComponents/categories-list/categories-list.component';
import { PremiumAdsComponent } from './components/sharedComponents/premium-ads/premium-ads.component';
import { LocationDetailsComponent } from './components/sharedComponents/location-details/location-details.component';
import { SimilerProductComponent } from './components/sharedComponents/similer-product/similer-product.component';
import { BusinessComponent } from './components/business/business.component';
import { BusinessListComponent } from './components/business/business-list/business-list.component';
import { BusinessDetailsComponent } from './components/business/business-details/business-details.component';
import { BusinessCardComponent } from './components/business/business-list/business-card/business-card.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { RouterModule } from '@angular/router';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ExtraProductsComponent } from './components/sharedComponents/extra-products/extra-products.component';
import { WorkingDetailsComponent } from './components/sharedComponents/working-details/working-details.component';
import { ReviewComponent } from './components/sharedComponents/review/review.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { StarRatingComponent } from './components/sharedComponents/star-rating/star-rating.component';
import { SearchComponent } from './components/search/search.component';
import { SearchListComponent } from './components/search/search-list/search-list.component';
import { BusinessFiltersComponent } from './components/business/filters/businessFilters.component';
import { SearchFiltersComponent } from './components/search/filters/searchFilters.component';
import { MapComponent } from './components/shared/map/map.component';
import { ContactComponent } from './components/staticPages/contact/contact.component';
import { HidePipe } from './components/sharedComponents/location-details/hide.pipe';
import { PremiumAdsSliderComponent } from './components/sharedComponents/premium-ads-slider/premium-ads-slider.component';
import { QRCodeModule } from 'angularx-qrcode';
import { SiteMapComponent } from './components/staticPages/site-map/site-map.component';
import { BusinessSlugModule } from './components/sharedComponents/business-slug.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    SubFooterComponent,
    BusinessComponent,
    BusinessListComponent,
    BusinessCardComponent,
    BusinessDetailsComponent,
    FiltersComponent,
    ProductsComponent,
    ProductListComponent,
    ProductCardComponent,
    ProductDetailsComponent,
    AlertComponent,
    SendEnquiryComponent,
    CategoriesListComponent,
    PremiumAdsComponent,
    PremiumAdsSliderComponent,
    LocationDetailsComponent,
    SimilerProductComponent,
    ExtraProductsComponent,
    WorkingDetailsComponent,
    ReviewComponent,
    StarRatingComponent,
    SearchComponent,
    SearchListComponent, 
    SearchFiltersComponent,
    BusinessFiltersComponent,
    MapComponent,
    ContactComponent,
    HidePipe,
    SiteMapComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    BusinessSlugModule,
    SharedModule,
    CommonModule,
    NgPipesModule,
    NgxPaginationModule,
    NgSelectModule, NgxSpinnerModule, RouterModule, NgbModule, NgbNavModule, FontAwesomeModule, QRCodeModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy},
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
